import {
  formSpecification as commonFormSpecification,
  type McaAccompanimentFormData as CommonMcaAccompanimentFormData,
} from "../common/mcaAccompaniment.js";

export const formSpecification = commonFormSpecification;

export type McaAccompanimentFormData = CommonMcaAccompanimentFormData;
